<section class="empty-state" role="status" [attr.dir]="globalService.isRTL ? 'rtl' : 'ltr'">
  <span class="empty-state-icon" aria-hidden="true"><i class="fas" [ngClass]="icon"></i></span>
  <h3>{{ heading }}</h3>
  <p *ngIf="showDescription">{{ description }}</p>
  <button *ngIf="actionLabel" type="button" class="btn btn-outline-primary" (click)="action.emit()">{{ actionLabel }}</button>
</section>
